module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e872531"
    }
  }, [_c('b', [_vm._v("ARTICHOKE DIP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e873031"
    }
  }, [_c('b', [_c('i', [_vm._v("Serve this simple dip along with crisp toasted wedges of pita bread. An assortment of olives and cherry tomatoes makes a tasty accompaniment.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0031_001",
      "src": "Images/9781618371621_0031_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap",
    attrs: {
      "id": "d7e872031"
    }
  }, [_c('i', [_vm._v("Artichoke Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e874331"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e874931"
    }
  }, [_vm._v("1 lemon")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e875231"
    }
  }, [_vm._v("1 can (13.75 ounces) artichoke hearts, drained")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e875531"
    }
  }, [_vm._v("¼ cup light mayonnaise")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e876431"
    }
  }, [_vm._v("¼ cup freshly grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e877431"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e877931"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" From lemon, grate ½ teaspoon peel and squeeze 2 teaspoons juice.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e879831"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" In food processor with knife blade attached, puree lemon peel and juice, artichoke hearts, Parmesan, and oil until smooth. Transfer to serving bowl. If not serving right away, cover and refrigerate up to 3 days. Makes about 1¼ cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e882831"
    }
  }, [_vm._v("Each tablespoon: About 30 calories, 1g protein, 1g carbohydrate, 3g total fat (1g saturated), 2mg cholesterol, 70mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c0814c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c12_r1.vue
// module id = 102
// module chunks = 0